import { normalizeResolvedPath } from '../paths/normalize-resolved-path.js';
import type { SessionWorktreeManager } from '../worktrees/manager.js';
import { getBridgeRoot } from './cwd/index.js';

/** Absolute session parent path the file browser may list/read/search under (bridge root or session worktree parent). */
export async function resolveFileBrowserSessionParent(
  sessionWorktreeManager: SessionWorktreeManager,
  sessionId?: string,
): Promise<string> {
  const sid = sessionId?.trim();
  if (sid) {
    await sessionWorktreeManager.ensureRepoCheckoutPathsForSessionAsync(sid);
    const worktreeRoot = sessionWorktreeManager.getSessionWorktreeRootForSession(sid);
    if (worktreeRoot) return normalizeResolvedPath(worktreeRoot);
  }
  return getBridgeRoot();
}
